import React from 'react';
import _ from 'lodash';

import {
  LoadingOverlay,
  Table
} from 'iron-forge-react-modules';

import * as dataService from './dataService';
import * as types from './types';



const TableComponent = Table.genTableComponent<types.IColumnId>();



export const FC: React.FC = () => {
  const {
    queryTuple,
    pageInfo,
    fnQueryPage
  } = dataService.useQuery();
  const [
    fnExportNetSuiteXmlRequests,
    exportNetSuiteXmlRequests
  ] = dataService.useExportNetSuiteXmlRequests();

  const loading = exportNetSuiteXmlRequests.loading || queryTuple.loading;

  return (
    <>
      <LoadingOverlay.FC active={loading} />

      <TableComponent
        disableSorting
        paginationOptions={Table.pageInfo2PaginationOptions(pageInfo, fnQueryPage)}
        multiSelectOptions={{
          onClickPopoverOption: (orderIds, optionId) => {
            if (optionId === 'writeToNetSuite') {
              fnExportNetSuiteXmlRequests(orderIds);
            }
          },
          popoverOptions: [
            {
              id: 'writeToNetSuite',
              label: `Generate Requests`
            }
          ]
        }}
        initSortOptions={{
          columnId: 'orderDate',
          direction: 'descending'
        }}
        columns={[
          {
            id: 'orderNumber',
            label: "Order Number"
          },
          {
            id: 'orderDate',
            label: "Order Date"
          },
          {
            id: 'customerEmail',
            label: "Customer Email"
          },
          {
            id: 'storeName',
            label: "Store Name"
          },
          {
            id: 'departmentName',
            label: "Department"
          },
          {
            id: 'subsidiaryName',
            label: "Subsidiary"
          },
          {
            id: 'inventoryLocationName',
            label: "Inventory Location"
          },
          {
            id: 'taxItemName',
            label: "Tax Item"
          }
        ]}
        rows={_.map(queryTuple.data.rows, (row): types.IRow => ({
          id: row.id,
          columnId2Value: {
            orderNumber: {
              type: 'string',
              label: row.orderNumber
            },
            orderDate: {
              type: 'string',
              label: row.orderDate.toFormat('yyyy-MM-dd')
            },
            customerEmail: {
              type: 'string',
              label: row.customerEmail
            },
            storeName: {
              type: 'string',
              label: row.storeName
            },
            departmentName: {
              type: 'string',
              label: row.departmentId
            },
            inventoryLocationName: {
              type: 'string',
              label: row.inventoryLocationId
            },
            subsidiaryName: {
              type: 'string',
              label: row.subsidiaryId
            },
            taxItemName: {
              type: 'string',
              label: row.taxItemName
            }
          }
        }))} />
    </>
  );
};
